
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from "@/hooks/use-toast";
import { addCountry } from './country/countryOperations';
import { extractCountryErrorMessage } from './country/errorHandlers';

export interface CountryMutationResult {
  addCountryMutation: ReturnType<typeof useMutation<void, Error, string>>;
}

export const useCountryMutations = (): CountryMutationResult => {
  const { toast } = useToast();
  const queryClient = useQueryClient();

  const addCountryMutation = useMutation({
    mutationFn: addCountry,
    onSuccess: () => {
      toast({ title: "Success", description: "Country added successfully" });
      // Invalidate and refetch countries
      queryClient.invalidateQueries({ queryKey: ['countries'] });
    },
    onError: (error) => {
      const errorMessage = extractCountryErrorMessage(error);
      toast({ 
        title: "Error", 
        description: errorMessage, 
        variant: "destructive" 
      });
    }
  });

  return {
    addCountryMutation
  };
};
